import { ANGLES } from 'domains/fast-sell-image/constants'

const initialImages = (images) => {
  // put initial image if exist
  const displayImage = (angle) => images && images.find((image) => image?.angle === angle?.value)
  return (
    ANGLES.map((angleOption) => {
      const isCover = angleOption.value === 'front'
      const image   = displayImage(angleOption)
      return image || ({
        is_cover : isCover,
        order    : angleOption.order,
        angle    : angleOption.value
      })
    })
  )
}

const fastSellProductFormInitialValues = (fastSellProduct) => {
  const priceOffers     = fastSellProduct?.price_offers || []
  const firstPriceOffer = priceOffers[ 0 ]

  return ({
    id                  : fastSellProduct?.id || '',
    name                : fastSellProduct?.name || '',
    seller_id           : fastSellProduct?.seller?.id || '',
    product_brand_id    : fastSellProduct?.product_brand?.id || '',
    product_category_id : fastSellProduct?.product_category?.id || '',
    condition           : fastSellProduct?.condition || '',
    details             : fastSellProduct?.details || [],
    serial_code         : fastSellProduct?.serial_code || '',
    price_offer         : firstPriceOffer?.price || '',
    year_purchased      : fastSellProduct?.year_purchased || '',
    status              : fastSellProduct?.status || '',
    received_status     : fastSellProduct?.received_status || '',
    note                : fastSellProduct?.note || '',
    images              : initialImages(fastSellProduct?.images) || '',
    otherDetail         : ''
  })
}


export default fastSellProductFormInitialValues
